import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalOverlay, ModalContent, ModalHeader, ModalBody, CloseButton } from './style';

const WelcomeModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <h2>{t('welcomeTitle')}</h2>
          <CloseButton onClick={onClose}>&times;</CloseButton>
        </ModalHeader>
        <ModalBody>
          <p>{t('welcomeText')}</p>
        </ModalBody>
      </ModalContent>
    </ModalOverlay>
  );
};

export default WelcomeModal;
